import { createStore, applyMiddleware } from 'redux';
import tagManagerReducer from '../reducers/tagManagerReducer';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';

const configureStore = (railsProps) => (
  createStore(tagManagerReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
